/**
 * @generated SignedSource<<4f5e332f5f580cdac6c6c97eb715d02c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutAddressReview_address$data = {
  readonly company: string | null;
  readonly displayCountry: string | null;
  readonly formattedAddress: ReadonlyArray<string | null> | null;
  readonly " $fragmentType": "CheckoutAddressReview_address";
};
export type CheckoutAddressReview_address$key = {
  readonly " $data"?: CheckoutAddressReview_address$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutAddressReview_address">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutAddressReview_address",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "company",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayCountry",
      "storageKey": null
    }
  ],
  "type": "Address",
  "abstractKey": null
};

(node as any).hash = "b2ea723e2039ee1a96151c2fb6c5fc6c";

export default node;
